//归集仓管理 api
import request from '@/utils/request'
const baseService = 'autoapp-default-server-recovery'

/**
获取列表
 */
export function getOldMachinePrice(data) {
  return request({
    url: `${baseService}/api/oldMachinePrice/page`,
    method: 'post',
    data
  })
}

/**
 * 价格展示/销司价格展示 - 分页条件查询
 * @param {object} data - 请求参数
 * @param {string} data.salesCompanyCode - 销司编码
 * @param {string} data.category - 品类：CABINET柜机 / WALL_MOUNT挂机
 * @param {string} data.pricingMode - 计价方式：WEIGHT按重量 / SETS按套数
 * @param {number} data.pageNum - 当前页码
 * @param {number} data.pageSize - 每页条数
 * @param {string} data.updateTimeFrom - 更新时间起
 * @param {string} data.updateTimeTo - 更新时间止
 */
export function getPriceDisplayPage(data) {
  return request({
    url: `${baseService}/api/priceDisplay/page`,
    method: 'post',
    data
  })
}

/**
 * 价格展示/销司价格展示 - 新增/编辑价格配置
 * @param {object} data - 请求参数
 * @param {number} data.id - 主键：新增时为空，编辑时必传
 * @param {string} data.salesCompanyCode - 销司编码（必填）
 * @param {string} data.category - 品类：CABINET柜机 / WALL_MOUNT挂机（必填）
 * @param {string} data.pricingMode - 计价方式：WEIGHT按重量 / SETS按套数（必填）
 * @param {number} data.brand - 品牌：1格力 2非格力（套数模式必填）
 * @param {string} data.hasCopperPipe - 是否含铜管：YES含 / NO不含（必填）
 * @param {string} data.horsepower - 匹数（套数模式必填）
 * @param {string} data.panelType - 面板类型：SINGLE单片 / DOUBLE双片（重量模式必填）
 * @param {number} data.price - 价格（必填，最小0.01）
 */
export function savePriceDisplay(data) {
  return request({
    url: `${baseService}/api/priceDisplay/save`,
    method: 'post',
    data
  })
}

/**
 * 价格展示/销司价格展示 - 编辑价格配置
 * @param {object} data - 请求参数（与新增相同，id 必传）
 */
export function updatePriceDisplay(data) {
  return request({
    url: `${baseService}/api/priceDisplay/update`,
    method: 'post',
    data
  })
}

/**
 * 价格展示/销司价格展示 - 查询变更日志
 * @param {number} id - 价格配置记录ID（query参数）
 * @returns {Promise<object>} data 为 PriceDisplayLogVO 数组
 *   - operatorName {string} 变更人姓名
 *   - operateTime {Instant} 变更时间
 *   - changeContent {string} 变更内容
 */
export function getPriceDisplayLogs(id) {
  return request({
    url: `${baseService}/api/priceDisplay/logs`,
    method: 'post',
    params: { id }
  })
}

/**
 * 价格展示/销司价格展示 - 删除价格配置
 * @param {number} id - 价格配置记录ID（query参数）
 */
export function deletePriceDisplay(id) {
  return request({
    url: `${baseService}/api/priceDisplay/delete`,
    method: 'post',
    params: { id }
  })
}

/**
 * 价格展示/销司价格展示 - 获取所有销售公司枚举值
 * @returns {Promise<object>} data 为 List<Map<String, String>>，每项包含 code(编码) 和 name(名称)
 */
export function getSalesCompanies() {
  return request({
    url: `${baseService}/api/priceDisplay/salesCompanies`,
    method: 'get'
  })
}

/**
更新数据
 */
export function updateOldMachinePrice(data) {
  return request({
    url: `${baseService}/api/oldMachinePrice/update`,
    method: 'post',
    data
  })
}

/**
新增数据
 */
export function addOldMachinePrice(data) {
  return request({
    url: `${baseService}/api/oldMachinePrice/add`,
    method: 'post',
    data
  })
}

/**
获取修改日志
 */
export function getUpdateLogs(id) {
  return request({
    url: `${baseService}/api/oldMachinePrice/updateLogs/${id}`,
    method: 'get'
  })
}

// /**
// 导出归集仓列表
//  */
// export function exportWarehouse(data) {
//   return request({
//     url: `${baseService}/api/warehouse/export`,
//     method: "post",
//     data
//   });
// }

// /**
// 查看归集仓详情
//  */
// export function getWarehouseByNo(warehouseNo) {
//   return request({
//     url: `${baseService}/api/warehouse/getWarehouseByNo/${warehouseNo}`,
//     method: "post"
//   });
// }

// /**
// 归集仓启停
//  */
// export function updateWarehouseStatus(warehouseNo, status) {
//   return request({
//     url: `${baseService}/api/warehouse/updateWarehouseStatus/${warehouseNo}/${status}`,
//     method: "PUT"
//   });
// }

// /**
// 添加归集仓
//  */
// export function saveWarehouse(data) {
//   return request({
//     url: `${baseService}/api/warehouse/saveWarehouse`,
//     method: "post",
//     data
//   });
// }

// /**
// 编辑归集仓
//  */
// export function updateWarehouse(data) {
//   return request({
//     url: `${baseService}/api/warehouse/updateWarehouse`,
//     method: "put",
//     data
//   });
// }

// /**
// 归集仓区域分配列表查询
//  */
// export function findWarehouseAllocate(data) {
//   return request({
//     url: `${baseService}/api/warehouse/findWarehouseAllocate`,
//     method: "post",
//     data
//   });
// }

// /**
// 导出归集仓区域分配列表
//  */
// export function exportWarehouseAllocate(data) {
//   return request({
//     url: `${baseService}/api/warehouse/exportWarehouseAllocate`,
//     method: "post",
//     data
//   });
// }

// /**
// 分配归集仓区域
//  */
// export function warehouseAllocate(data) {
//   return request({
//     url: `${baseService}/api/warehouse/warehouseAllocate`,
//     method: "post",
//     data
//   });
// }

// /**
// 获取归集仓下拉列表用于与分配
//  */
// export function findAllWarehouseOption() {
//   return request({
//     url: `${baseService}/api/warehouse/findAllWarehouse`,
//     method: "post"
//   });
// }

// /**
// 获取归集仓状态枚举值
//  */
// export function findWarehouseStatusOption() {
//   return request({
//     url: `${baseService}/api/warehouse/findWarehouseStatus`,
//     method: "post"
//   });
// }

// /**
// 获取是否 WMS仓库枚举值
//  */
// export function findWmsWarehouseOption() {
//   return request({
//     url: `${baseService}/api/warehouse/findWmsWarehouse`,
//     method: "post"
//   });
// }



// WEBPACK FOOTER //
// ./src/api/oldValuation.js